import React, { useState } from "react";
import MessagePicker from "../../../Components/MessagePicker";
import { TNotifyAction, TLevel } from "./types";
import { useTranslation } from "react-i18next";

interface INotifyActionFormProps {
  action: TNotifyAction;
  onChange: (notifyAction: TNotifyAction) => void;
}

const NotifyActionForm = (props: INotifyActionFormProps) => {
  const { action, onChange } = props;
  const [notifyAction, setNotifyAction] = useState<TNotifyAction>(action);
  const { t } = useTranslation();

  const updateNotifyAction = (newNotifyAction: TNotifyAction) => {
    setNotifyAction(newNotifyAction);
    onChange(newNotifyAction);
  };

  return (
    <>
      <MessagePicker
        fullWidth
        label={t("Message")}
        title={t(notifyAction.title)}
        text={t(notifyAction.text)}
        level={notifyAction.level}
        onMessageChange={(title: string, text: string, level: TLevel) => {
          updateNotifyAction({
            ...notifyAction,
            title,
            text,
            level: level,
          });
        }}
        data-cy="notify-action-message-picker"
      />
    </>
  );
};

export default NotifyActionForm;
